'use client';
import { useRetentionHomePageData } from '@finn/auto-ui/modules/home/useRetentionHomePageData';
import { useFeatureOverrides } from '@finn/ua-featureflags';

import PageBodyBuilder from '~/ui-modules/PageBodyBuilder';
import { LandingPageProps } from '~/utils/landingPage';

import { homePageldScripts } from '../../home';

type Props = {
  experiment?: string;
  variant?: string;
  overrideLogin?: boolean;
} & LandingPageProps;

export const Ab = ({
  pageData,
  reviews,
  brands,
  slug,
  experiment,
  variant,
  overrideLogin,
}: Props) => {
  useFeatureOverrides(experiment, variant);
  const { retentionPageData } = useRetentionHomePageData(overrideLogin);

  const replacedPageData =
    slug === 'home-new' && retentionPageData ? retentionPageData : pageData;

  return (
    <PageBodyBuilder
      data={replacedPageData}
      reviews={reviews}
      brands={brands}
      jsonLdContentArr={
        slug === 'home-new'
          ? homePageldScripts.map((item) => JSON.stringify(item, null, 4))
          : undefined
      }
    />
  );
};
